import React from 'react'

interface TitleProps {
    text: string;
  }
  
  export const Title: React.FC<TitleProps> = ({ text }) => {
    return (
      <h2>{text}</h2>
    );
  }
  
